<template>

  <!-- ************* PRODOTTI DELLA SEZIONE **********  -->
  <!-- Mostra gli articoli che il fornitore Eurete vende -->
  <div>
    <PageTagline :elements="tagline_elem" />

    <CustomOverlay :show="overlay_show" text="Caricamento in corso, attendere...">

      <!-- Pulsante per tornare alla pagina delle sezioni -->
      <b-button pill size="sm" @click="$router.push( { name : 'conv-eurete-buoni' } )">
        <b-icon icon="caret-left-fill"></b-icon>Torna indietro
      </b-button>

      <!-- NOME E DESCRIZIONE DELLA SEZIONE -->
      <!-- Usiamo il v-if per visualizzare le informazioni    -->
      <!-- solo quando queste sono effettivamente disponibili -->
      <b-row class="mt-4" align-h="center">
        <b-col class='text-center mb-3'>
          <h2 class="section-title" v-if="info_sezione !== null">{{info_sezione.nome}}</h2>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <!-- Su schermi grandi occupa solo 4 colonne, su quelli di medie dimensioni 10 -->
        <b-col class='text-justify' lg="4" md="10">
          <h6 class="section-description" v-if="info_sezione !== null" v-html="info_sezione.descrizione"></h6>
        </b-col>
      </b-row>

      <!-- CONTENUTO DELLA VETRINA -->
      <div class="mt-5">
        <!-- Overlay di caricamento della vetrina: per caricamento al cambio pagina -->
        <b-overlay :show="overlay_vetrina" spinner-variant="primary">
          <!-- VETRINA -->
          <!-- Se non ci sono prodotti disponibili visualizziamo un messaggio invece della pagina vuota -->
          <b-row v-if="parted_vetrina.length === 0 ">
            <b-col class="text-center">Nessun elemento acquistabile con il credito Art51c3 a disposizione</b-col>
          </b-row>

          <!-- Altrimenti andiamo a renderizzare la lista -->
          <b-row v-else v-for="(row_elem, index) in parted_vetrina" :key="index" >
            <!-- Mettiamo 4 elementi per riga ( md-3 grandezza colonna 3)    -->
            <!-- sugli schermi piccoli andiamo in stacked, mentre la colonna -->
            <!-- è alta il 100% della riga ( classe h-100 ) -->
            <b-col :cols="item_column_size" class="text-center h-100 mb-3 pb-2" v-for="( articolo, index ) in row_elem" :key="index">
              <b-row>
                <b-col cols="12">
                  <b-link class="item-link" @click="mostra_modale_acquisto(articolo)" :title="articolo.nome">
                    <!-- NOME DEL PRODOTTO -->
                    <h5 class="mt-2 title-text text-center">{{articolo.nome}}</h5>
                    <!-- COSTO DEL PRODOTTO -->
                    <h5 class="mt-1 text-center">€ {{articolo.costo}}</h5>
                    <!-- DESCRIZIONE DEL PRODOTTO -->
                    <h6 class="description-text text-center">{{articolo.descrizione}}</h6>
                    <!-- ICONA DEL PRODOTTO -->
                    <b-img fluid class="logo-image" :src="get_url_icona(articolo.icona)" :alt="articolo.nome"></b-img>
                  </b-link>
                </b-col>
                <!-- LINK ALLE INFORMATIVE -->
                <b-col class="mt-2" cols="12">
                  <!-- LINK SCHEDA TECNICA -->
                  <b-button class="m-1" :href="articolo.url_scheda" target="_blank" variant="secondary" size="sm">SCHEDA TECNICA</b-button>
                  <!-- LINK REGOLAMENTO -->
                  <b-button class="m-1" :href="articolo.url_regolamento" target="_blank" variant="secondary" size="sm">REGOLAMENTO</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- PAGINATORE -->
          <b-pagination v-model="current_page"
                        v-if="show_paginatore"
                        :total-rows="total_rows"
                        :per-page="page_size"
                        @input="update_prodotti_da_paginatore"
                        align="center">
          </b-pagination>
        </b-overlay>
      </div>
    </CustomOverlay>

    <!-- MODALE DI ACQUISTO DEL PRODOTTO -->
    <b-modal  size="lg"
              centered
              no-close-on-backdrop
              no-close-on-esc
              hide-header-close
              :title='acq_modal_prod.nome'
              v-model="show_acq_modal"
              >
      <b-row>
        <b-col cols='md-6' class='text-center'>
          <span class="align-helper"></span>
          <!-- Dovendo usare require possiamo visualizzare questa immagine -->
          <!-- solo quando davvero disponibile per questo usiamo il v-if   -->
          <b-img v-if="acq_modal_prod.icona" fluid :src="get_url_icona(acq_modal_prod.icona)"></b-img>
        </b-col>
        <b-col cols='md-6' class='mt-3 text-justify'>
          <p v-html="acq_modal_prod.descrizione"></p>
        </b-col>
      </b-row>
      <!-- Ridefiniamo i bottoni, nel nostro caso serve il bottone annulla e quello di acquisto  -->
      <!-- viene inoltre controllato che l'utente abbia sufficiente credito per poter proseguire -->
      <!-- in tal caso viene visualizzato il messaggio di errore e non il pulsante acquista.     -->
      <template v-slot:modal-footer>
        <p v-if="is_credit_out" class='text-danger text-justify'>
          Non hai sufficiente credito per proseguire.
          Il massimo spendibile in quest'area utilizzando il credito welfare,
          ammonta a quanto attualmente disponibile per i buoni ( art. 51c3 ) e pari a
          {{ $store.state.user.user_credito.art51c3 }} €.
          Seleziona un altro elemento dall'elenco il cui valore non superi tale cifra.
        </p>
        <b-button v-else size="sm" variant="primary" @click="esegui_acquisto()">
          Acquista
        </b-button>
        <b-button size="sm" variant="secondary" @click="chiudi_modale_acquisto()">
          Annulla
        </b-button>
      </template>
    </b-modal>

  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'VetrinaEurete',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "ExAnte Mutua", link : 'conv-eurete-buoni' },
                       { text : "Prodotti", link : '' } ],

      overlay_show: false,

      // Overlay specifico per la vetrina quando
      // viene cambiata la pagina.
      overlay_vetrina: false,

      // Informazioni sulla sezione
      info_sezione: null,

      // Lista dei prodotti
      prodotti : [],


      // Numero di elementi per ogni riga
      item_by_row: 4,

      // Dimensione delle colonne con gli item, siccome
      // vogliamo avere 4 elementi per riga utilizziamo
      // la classe bootstrap md-3 ( 12/3 = 4 )
      item_column_size: "md-3",

      // -- Paginatore: --
      // Elementi per ogni pagina della vetrina, siccome
      // vogliamo mostrare 2 righe per pagina richiederemo
      // al backend una pagina di 8 elementi.
      page_size: 8,
      // Pagina corrente ( dato valorizzato dal paginatore di bootstrap )
      // partiamo cmq con la prima.
      current_page: 1,
      // Numero totale di elementi ( dato valorizzato dal backend )
      total_rows : null,

      // -- Acquisto: --
      // Prodotto scelto dall'utente da passare alla modale di acquisto.
      // Essendo richiesto un oggetto per renderizzare le info nella modale,
      // ne passo uno vuoto invece che null altrimenti avrei errore da
      // parte del componente.
      acq_modal_prod : {},
      // Boolean per aprire e chiudere la modale di acquisto collegata al
      // suo v-model
      show_acq_modal : false

    }
  },
  computed : {
     /**
     * Partiziona i prodotti da array singola ad un'array di array
     * con 4 elementi per ogni sotto array ( ogni sotto array è una riga ).
     */
    parted_vetrina : function () {
      return generalLib.sub_array_partition( this.prodotti, this.item_by_row );
    },
    /**
     * Una variabile che indica se il paginatore deve comparire.
     * Dovrà essere visibile quando il numero di elementi totali supera
     * quello degli elementi in una pagina.
     */
    show_paginatore : function () {
      let res = false;
      if ( this.total_rows > this.page_size ) res = true;
      return res;
    },
    /**
     * Un flag che segnala, all'apertura della modale di acquisto,
     * che non è possibile continuare perchè il credito relativo
     * ai buoni non è sufficiente.
     */
    is_credit_out : function () {
      return this.$store.state.user.user_credito.art51c3 < this.acq_modal_prod.costo ? true : false;
    }
  },
  methods : {
    carica_prodotti : function ( page_num = null ) {

      // Nella chiamata per Django specifichiamo sempre nella query string
      // la grandezza della pagina ( numero di elementi nella pagina restituita )
      // ed il fatto che vogliamo i prodotti ordinati per prezzo.
      let params = { page_size : this.page_size };

      // Se specificato andiamo a settare in query string il numero di pagina richiesto
      // altrimenti stiamo facendo il primo caricamento che parte dalla prima pagina.
      if ( page_num != null ) params['page'] = page_num;

      let call_url = apiUrl.eureteapi.get_prodotti_by_sezione.replace( '@slug_name', this.slug_name )

      this.overlay_vetrina = true;

      axios.get( call_url, { params: params } )
      .then( ( response ) => {
        // Aggiorniamo le variabili interne
        this.prodotti = response.data.results;
        this.total_rows = response.data.count;
        this.overlay_vetrina = false;
      })
      .catch( ( error ) => {
        this.overlay_vetrina = false;
        let message = "Si è verificato un errore nel caricamento delle informazioni, " +
                      "si prega di riprovare, se il problema persiste contattare l'assistenza";
        generalLib.backend_error_message_box( this, message );
        console.error( error.response.data );
      });

    },
    /**
     * Quando si modifica la pagina tramite il paginatore va ricaricare gli
     * item nell'array dei prodotti selezionando la pagina voluta.
     */
    update_prodotti_da_paginatore : function () {
      this.carica_prodotti( this.current_page );
    },
    /**
     * Dal nome dell'icona della sezione torna l'url per la stessa
     */
    get_url_icona : function ( nome_icona ) {
        // L'unione tra il path e il nome dell'icona deve essere
        // fatto direttamente dentro il require e non in una variabile,
        // perchè altrimenti webpack non saprebbe quali moduli includere
        // se il path è una variabile. Includendo invece parte del path
        // in modo statico sa cosa deve includere.
        // https://stackoverflow.com/questions/44673258/vuejs-cannot-find-module
        return require( '@/assets/eurete/' + nome_icona );
    },
    /**
     * Visualizza la modale per eseguire l'acquisto del prodotto desiderato.
     */
    mostra_modale_acquisto : function ( articolo ) {
      // Settiamo prima l'oggetto da mostrare in modale.
      this.acq_modal_prod = articolo;
      this.show_acq_modal = true;
    },
    /**
     * Chiude la modale di acquisto
     */
    chiudi_modale_acquisto : function () {
      this.acq_modal_prod = {};
      this.show_acq_modal = false;
    },
    /**
     * Esegue l'acquisto del prodotto desiderato.
     */
    esegui_acquisto : function () {

      // Le informazioni sul prodotto selezionato sono quelle
      // riportate nell'oggetto acq_modal_prod valorizzato all'apertura
      // della modale di acquisto.
      if (  this.acq_modal_prod === {} || this.acq_modal_prod === null ) {
        throw Error( 'Impossibile proseguire con l\'acquisto, articolo da acquistare non definito.' );
      }

      generalLib.acquisto_confirm_message_box (  this, this.acq_modal_prod.costo, 'art51c3' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla, chiudo la modale di acquisto
        // e torno.
        if ( !value ) {
          this.chiudi_modale_acquisto();
          return;
        }

        // Se invece l'utente decide di proseguire:
        // 1) Prendo lo slug name del prodotto da acquistare da inviare al
        //    backend perchè la successiva chiusura della modale di acquisto
        //    resetta tale informazione
        // 2) Chiudo la modale di acquisto
        // 3) Attivo l'overlay di attesa nel mentre che viene effettuata la richiesta
        let data_to_send = { product_slug : this.acq_modal_prod.slug_name }
        this.chiudi_modale_acquisto();
        this.overlay_show = true;

        axios.post( apiUrl.welfareapi.create_acq_eurete, data_to_send )
        .then( (response) => {

          this.overlay_show = false;

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home. Non possiamo usare quella della general lib perchè dobbiamo personalizzare
          // il messaggio.
          let mess = "La richiesta è stata inviata con successo con l'id " + response.data.id_acquisto +
                     ". Riceverai a breve un messaggio nella tua area notifiche welfarebit, con il link " +
                     "per accedere al sito web del nostro partner, al fine di immettere le ulteriori " +
                     "informazioni necessarie per attivare il sussidio richiesto. Il link è consultabile " +
                     "solo tramite tale area e non ti sarà inviato via mail. In caso di difficoltà nel " +
                     "reperire il link ti invitiamo a contattare il nostro servizio assistenza."
          this.$bvModal.msgBoxOk( mess , {
            title: 'Richiesta inviata',
            buttonSize: 'sm',
            okVariant: 'success',
            centered: true
          })
          .then( ( value ) => {
            this.$router.push( { name : 'menu'} );
          })

        })
        .catch( (error) => {
            this.overlay_show = false;
            generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });
    }
  },
  /**
   * In apertura carichiamo le info della sezione e poi i prodotti
   */
  created : function () {

    this.overlay_show = true;

    let call_url = apiUrl.eureteapi.get_info_sezione.replace( '@slug_name', this.slug_name );

    axios.get( call_url )
    .then( ( response ) => {
      this.info_sezione = response.data;
      this.overlay_show = false;
      this.carica_prodotti();
    })
    .catch( ( error ) => {
      this.overlay_show = false;
      generalLib.backend_error_message_box( this, error.response.data );
    });

  },
  props : {
    /**
     * Slug name della sezione che deve essere visualizzata
     */
    slug_name: {
      type: String,
      default: null
    }
  },
  components: {
    PageTagline,
    CustomOverlay
  }
}
</script>


<style scoped>

/* Titolo della sezione: in questa pagina
   rendiamo il titolo tutto a lettere grandi */
.section-title {
  text-transform: uppercase;
}

/* Descrizione della sezione */
.section-description {
  font-weight: 400;
}

/* icona che mostra il prodotto */
.item-link {
  color: #000000;
  text-decoration: none;
}
.item-link:hover {
  filter: blur(1px);
}

/* l'immagine del prodotto la rimpiccioliamo
   un poco per fittare meglio nella pagina */
.logo-image {
  max-width: 70%;
}

/* Sistemiamo il testo del titolo dei sussidi
   poniamo l'altezza della linea ad 1em e rendiamo
   tutti gli elementi dei titoli alti 2 righe
   per mantenere l'allineamento */
.title-text {
  line-height:1em;
  min-height:2em;
}

/* Sistemiamo il testo descrittivo dei sussidi
   poniamo l'altezza della linea ad 1em e rendiamo
   tutti gli elementi alti 3 righe per mantenere
   l'allineamento. Sfiniamo un poco il testo. */
.description-text {
  font-weight: 400;
  line-height:1em;
  min-height:3em;
}

</style>